/**
 * Decode a base64url VAPID public key into the byte array
 * `PushManager.subscribe` expects.
 *
 * Shared by the Rider and customer registration paths (issue #93) so the two
 * cannot drift apart on the padding rules.
 */
export function urlBase64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    arr[i] = raw.charCodeAt(i);
  }
  return arr;
}
